<script>
/* eslint-disable */
import moment from 'moment'
export default {
  props: {
    dateValue: {
      type: String,
      default: moment(new Date()).format('YYYY-MM-DD'),
    },
    timeValue: {
      type: String,
      default: '00:00',
    },
    formatString: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    showSelected: {
      type: Boolean,
      default: false,
    },
    selectedDate: {
      type: Date,
      default: () => new Date(),
    },
  },
  data() {
    return {
      currentYear: 1970, // 年份
      currentMonth: 1, // 月份
      currentDay: 1, // 日期
      currentWeek: 1, // 星期
      days: [],
      value1: '',
      tabIndex: null,
      tabTimeIndex: 0,
      times: ['00:00~06:00', '06:00~12:00', '12:00~18:00', '18:00~24:00', '今日节目'],
    }
  },
  filters: {
    getWeekFormat(date) {
      const weeksObj = {
        1: '一',
        2: '二',
        3: '三',
        4: '四',
        5: '五',
        6: '六',
        7: '日',
      }
      let weekNumber = moment(date).isoWeekday()
      return weeksObj[weekNumber]
    },
  },

  mounted() {
    const index = _.findIndex(this.days, function (o) {
      // console.log('o: ', o.getDate());
      // console.log('new Date().getDate(): ', new Date().getDate());
      return o.getDate() === new Date().getDate()
    })
    this.tabIndex = index
  },

  created() {
    this.initData(null)
  },

  methods: {
    dateFormat(date) {
      return moment(date).format(this.formatString)
    },
    formatDate(year, month, day) {
      const y = year
      let m = month
      if (m < 10) m = `0${m}`
      let d = day
      if (d < 10) d = `0${d}`
      return `${y}-${m}-${d}`
    },
    pickDate(date) {
      let newDate = moment(date).format('YYYY-MM-DD')
      this.$emit('dateValue', newDate)
    },
    initData(cur) {
      let date = ''
      if (cur) {
        date = new Date(cur)
      } else {
        date = new Date()
      }
      this.currentDay = date.getDate() // 今日日期 几号
      this.currentYear = date.getFullYear() // 当前年份
      this.currentMonth = date.getMonth() + 1 // 当前月份
      this.currentWeek = date.getDay() // 1...6,0  // 星期几
      if (this.currentWeek === 0) {
        this.currentWeek = 7
      }
      const str = this.formatDate(this.currentYear, this.currentMonth, this.currentDay) // 今日日期 年-月-日
      this.days.length = 0
      // 今天是周日，放在第一行第7个位置，前面6个 这里默认显示一周，如果需要显示一个月，则第二个循环为 i<= 35- this.currentWeek
      /* eslint-disabled */
      for (let i = this.currentWeek - 1; i >= 0; i -= 1) {
        const d = new Date(str)
        d.setDate(d.getDate() - i)
        // console.log(y:" + d.getDate())
        this.days.push(d)
      }
      for (let i = 1; i <= 7 - this.currentWeek; i += 1) {
        const d = new Date(str)
        d.setDate(d.getDate() + i)
        this.days.push(d)
      }
    },

    // 上个星期
    weekPre() {
      const d = this.days[0] // 如果当期日期是7号或者小于7号
      d.setDate(d.getDate() - 7)
      this.initData(d)
    },

    // 下个星期
    weekNext() {
      const d = this.days[6] // 如果当期日期是7号或者小于7号
      d.setDate(d.getDate() + 7)
      this.initData(d)
    },

    // 上一個月  传入当前年份和月份
    pickPre(year, month) {
      const d = new Date(this.formatDate(year, month, 1))
      d.setDate(0)
      this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1))
    },

    // 下一個月  传入当前年份和月份
    pickNext(year, month) {
      const d = new Date(this.formatDate(year, month, 1))
      d.setDate(35)
      this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1))
    },

    // 当前选择日期
    pick(date, index) {
      // let newDate = moment(date).format('YYYY-MM-DD')
      // console.log('pick', date)
      this.$emit('update:selectedDate', date)
      this.$emit('change')
      // console.log("index: ", index);
      this.tabIndex = index
      // alert(
      //   this.formatDate(date.getFullYear(), date.getMonth() + 1, date.getDate())
      // );
    },
    pickTime(time, index) {
      // console.log('time: ', time);
      let timeArr = []
      timeArr.push(_.head(_.split(time, '~')))
      // console.log('timeArr: ', timeArr)
      this.$emit('timeValue', _.join(timeArr), '')
      // console.log("index: ", index);
      this.tabTimeIndex = index
      // alert(
      //   this.formatDate(date.getFullYear(), date.getMonth() + 1, date.getDate())
      // );
    },
    isToday(day) {
      return day.getFullYear() == new Date().getFullYear() && day.getMonth() == new Date().getMonth() && day.getDate() == new Date().getDate()
    },
    isSameSelected(day) {
      return moment(day).format('YYYY-MM-DD') === moment(this.selectedDate).format('YYYY-MM-DD')
    },
    isBeforeToday(day) {
      const inputDay = moment(day).format('YYYY-MM-DD')
      const todayDay = moment(new Date()).format('YYYY-MM-DD')
      return moment(inputDay).isBefore(todayDay)
    }
  },
}
</script>
<template>
  <div class="date">
    <el-row>
      <el-col :span="24">
        <div class="weeks">
          <!-- 日期 -->
          <ul class="days">
            <!-- <li @click="weekPre" class="prev-btn">
              <i class="fa fa-angle-left fa-icon" aria-hidden="true"></i>
              <span class="hidden-sm-and-down" style="margin-left: 5px;">上一周</span>
            </li> -->
            <li class="Jost" @click="pick(day, index)" v-for="(day, index) in days" :key="index"
              :class="{ today: isToday(day) }">
              <!--本月-->
              <span v-if="day.getMonth() + 1 != currentMonth" class="other-month item-wrapper">
                <p>{{ day | getWeekFormat }}</p>
                <span :class="{ selected: isSameSelected(day) && showSelected }">{{ dateFormat(day) }}</span>
              </span>
              <span v-else>
                <!--今天-->
                <!-- <span v-if="isToday(day)" class="today-item">今天</span>
                <span class="item-wrapper" v-else>
                  <p>{{ day | getWeekFormat }}</p>
                  <span class="hidden-sm-and-down">{{ dateFormat(day) }}</span>
                </span> -->
                <!-- <span v-if="isToday(day)" class="today-item">今天</span> -->
                <span class="item-wrapper">
                  <p>{{ day | getWeekFormat }}</p>
                  <!-- <span :class="{ selected: tabIndex === index && showSelected }">{{ dateFormat(day) }}</span> -->
                  <span :class="{ selected: isSameSelected(day) && showSelected, before: isBeforeToday(day) }">{{
                      dateFormat(day)
                  }}</span>
                </span>
              </span>
            </li>
            <!-- <li @click="weekNext" class="next-btn">
              <span class="hidden-sm-and-down" style="margin-right: 5px;">下一周</span>
              <i class="fa fa-angle-right fa-icon" aria-hidden="true"></i>
            </li> -->
            <!-- <li>
              <span>
                <el-date-picker class="right-pick-btn" style="width: 100%" @change="pickDate" v-model="value1" type="date" placeholder="按日期查询"></el-date-picker>
              </span>
            </li> -->
          </ul>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<style lang="css" scoped>
@media screen and (max-width: 1300px) {
  .days li {
    padding: 5px 0 !important;
  }
}

.weeks {
  width: 100%;
}

.today-item {
  cursor: pointer;
  line-height: 45px;
}

.selected {
  border: 1px solid white;
  box-shadow: 0 0 0 2px #41695b;
}
.before {
  color: #CDD2D3 !important;
}

.item-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.prev-btn,
.next-btn {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.prev-btn .fa-icon,
.next-btn .fa-icon {
  font-size: 18px;
}

.date {
  font-size: 14px;
  margin-top: 15px;
}

.date .time-range {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 10px 0;
}

.date .time-range span {
  cursor: pointer;
  padding-bottom: 5px;
  border-bottom: 3px solid #fff;
}

.date .time-range span:hover {
  border-bottom: 3px solid #97c6f5;
}

.date .time-range span:active {
  border-bottom: 3px solid #97c6f5;
}

.date .time-range .active {
  border-bottom: 3px solid #409eff;
}

.date .days {
  display: flex;
  height: 57px;
}

.date .days .arr-right {
  width: 7px;
  height: 7px;
  border-top: 2px solid #6e6a6a;
  border-right: 2px solid #6e6a6a;
  transform: rotate(45deg);
}

.date .days .arr-left {
  width: 7px;
  height: 7px;
  border-top: 2px solid #6e6a6a;
  border-left: 2px solid #6e6a6a;
  transform: rotate(-45deg);
}

.date .days li {
  cursor: pointer;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-right: none;
  list-style: none;
  flex: 1;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.date .days .date-item:hover {
  background: #dff0d8;
}

.date .days .date-item:active {
  background: #dff0d8;
}

.date .days li:nth-last-child(1) {
  border-right: 1px solid #ccc;
}
</style>
